import { createSvgIcon } from '@material-ui/core/utils';

/**
 * Rounded-square checkbox icons (platform design system), used as the MUI Checkbox defaults.
 * Corner radius ~6px at the default 24px icon size.
 */
const ROUNDED_BOX = 'M8 3h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5z';

export const RoundedCheckboxIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    d={`${ROUNDED_BOX}M8 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8z`}
  />,
  'RoundedCheckbox'
);

export const RoundedCheckboxCheckedIcon = createSvgIcon(
  <>
    <path d={ROUNDED_BOX} />
    <path fill="#fff" d="M10.2 15.6l-3.5-3.5 1.4-1.4 2.1 2.1 5.6-5.6 1.4 1.4z" />
  </>,
  'RoundedCheckboxChecked'
);

export const RoundedCheckboxIndeterminateIcon = createSvgIcon(
  <>
    <path d={ROUNDED_BOX} />
    <path fill="#fff" d="M7.5 11h9v2h-9z" />
  </>,
  'RoundedCheckboxIndeterminate'
);
